import {
  WarningCircleIcon,
  QuestionIcon,
  PackageIcon,
  ArrowCounterClockwiseIcon,
} from '@phosphor-icons/react';

export const Error = WarningCircleIcon;
export const Product = PackageIcon;
export const ProductOutOfStock = PackageIcon;
export const Unknown = QuestionIcon;
export const Reset = ArrowCounterClockwiseIcon;
